// src/app/services/zip-code-verification-rest.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { uuid } from '../shared/utils/uuid';
import { RuntimeConfigService } from './runtime-config';

export interface ZipCodeVerification {
  zipCodeVerification: {
    zipCodeIsValid: boolean;
    zipCodeStatus: string;
  };
}

/**
 * Validates a ZIP code against WWW REST before the residence section accepts it.
 */
@Injectable({
  providedIn: 'root',
})
export class ZipCodeVerificationRestService {
  constructor(
    private http: HttpClient,
    private readonly runtimeConfigService: RuntimeConfigService
  ) {}

  verifyZipCode(zipCode: string): Observable<ZipCodeVerification> {
    const headers = {
      'x-correlation-id': uuid(),
    };
    const { WWW_REST_API_URI } = this.runtimeConfigService.prequalConfig;
    return this.http.get<ZipCodeVerification>(
      WWW_REST_API_URI + '/api/location/zip-code/verify',
      { params: { zipCode }, headers }
    );
  }
}
